import { render } from "./SaveClaimEvent.vue?vue&type=template&id=334dffa7&scoped=true"
import script from "./SaveClaimEvent.vue?vue&type=script&lang=js"
export * from "./SaveClaimEvent.vue?vue&type=script&lang=js"

import "./save-claim-event.scss?vue&type=style&index=0&id=334dffa7&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334dffa7"]])

export default __exports__